// CRITICAL: Import Amplify configuration FIRST before anything else
import "./amplifyConfig"

// Now import everything else
import ThemeProvider from "@mui/material/styles/ThemeProvider"
import { datadogRum } from "@datadog/browser-rum"
import React from "react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import App from "./App"
import initializeDatadogRum from "./datadogRumConfig"
import { store } from "./store"
import hiabTheme from "./theme"
import { hasPerformanceCookieConsent } from "./utils/cookie"

// Dynamically inject OneTrust script so the domain script ID is read from
// the runtime environment variable (works in local dev, Docker, and production)
const oneTrustDomainScript = import.meta.env.VITE_APP_ONE_TRUST_DOMAIN_SCRIPT
if (oneTrustDomainScript) {
  const otScript = document.createElement("script")
  otScript.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
  otScript.type = "text/javascript"
  otScript.setAttribute("charset", "UTF-8")
  otScript.setAttribute("data-domain-script", oneTrustDomainScript)
  document.head.appendChild(otScript)

  const otWrapper = document.createElement("script")
  otWrapper.type = "text/javascript"
  otWrapper.text = "function OptanonWrapper() {}"
  document.head.appendChild(otWrapper)
}

// Initialize Datadog RUM with current consent state
initializeDatadogRum()

// Update Datadog tracking consent whenever the user changes their cookie preferences.
// OneTrust updates window.OnetrustActiveGroups before firing this event, so
// hasPerformanceCookieConsent() reflects the latest consent state.
window.addEventListener("OneTrustGroupsUpdated", () => {
  datadogRum.setTrackingConsent(hasPerformanceCookieConsent() ? "granted" : "not-granted")
})

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={hiabTheme}>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
)
